<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d3XzQd/images/9781439678008.jpg?1737821500087" alt="This image is the cover for the book Ghostly Tales of Columbia, Spooky America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghostly Tales of Columbia, Spooky America
      </h1>
      <p class="bookDescription body article font2">
        <p>Ghost stories from America's heartland have never been so creepy, fun, and full of mystery! <br/> Welcome to the spooky streets of Columbia, Missouri! <br/> Stay alert! Ghosts lurk around every corner. Even the most unexpected places might be haunted by wandering phantoms. <br/> Did you know ghostly soldiers reenact Civil War battles along one road in Woodlandville? Or that a demon pack of hunting dogs can still be heard baying on a haunted farm outside Columbia? Can you believe that in the home of the University president, a former resident decided never to leave? <br/> Pulled right from history, these ghostly tales will change the way you see Columbia and have you sleeping with the light on!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Emily Miller
      </h2>
      
      <p class="authorDescription body article">KAREN EMILY MILLER  has been writing about strange creatures since she was six years old, so writing about the paranormal is a perfect fit. She just moved to Iowa City and is excited to meet new ghosts there.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6686fbad